export default function Topbar() {
    return (
        <div className="container-fluid bg-dark px-5 d-none d-lg-block">
            <div className="row gx-0">
            <div className="col-lg-8 text-center text-lg-start mb-2 mb-lg-0">
                <div
                className="d-inline-flex align-items-center"
                style={{ height: 45 }}
                >
                <small className="me-3 text-light">
                    <i className="fa fa-map-marker-alt me-2" />
                    13680 Ficus Tree Ln, Bokeelia, FL
                </small>
                <small className="me-3 text-light">
                    <i className="fa fa-phone-alt me-2" />
                    +1 (239) 264-8150
                </small>
                <small className="text-light">
                    <i className="fa fa-envelope-open me-2" />
                    info@sunbayboats.com
                </small>
                </div>
            </div>
            </div>
        </div>
    );
}